<template>
  <div class="x-button">
    <el-button :size="size" :class="{ 'x-flex x-row-center': loading, 'x-disabled': disabled }" :style="{
      'background-color': bgc,
      'color': color,
      'border': border,
      'min-width': width,
      'margin-left': margin_left,
      'margin-right': margin_right
    }" :loading='loading' :disabled='disabled'>
      <div class="x-p-l-10 x-p-r-10">{{ title }}</div>
      <slot></slot>
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: [String],
      default: "small",
    },
    loading: {
      type: [Boolean],
      default: false,
    },
    disabled: {
      type: [Boolean],
      default: false,
    },
    title: {
      type: [String],
      default: "",
    },
    bgc: {
      type: [String],
      default: "#007AFB",
    },
    color: {
      type: [String],
      default: "#FFFFFF",
    },
    border: {
      type: [String],
      default: "1px solid #6396FC",
    },
    width: {
      type: [String],
      default: "90px",
    },
    height: {
      type: [String],
      default: "",
    },
    margin_left: {
      type: [String],
      default: "0px",
    },
    margin_right: {
      type: [String],
      default: "0px",
    },
  }
}
</script>

<style lang="less" scoped>
.x-button {
  font-size: 14px;

  /deep/.el-button {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  // border-radius: 4px;
  // /deep/.el-button {
  //   padding: 0px;
  // }

  &:hover {
    cursor: pointer;
    opacity: 0.8;

  }

  &:active {
    opacity: 0.5;
  }
}

.x-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/xButton.vue